









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeletePartner, QueryPartnerList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditPartnerDialog from './EditPartnerDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EditPartnerDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '合伙人名称', param: 'name' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建合伙人', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '合伙人名称', param: 'name' },
    { title: '层级', param: 'level' },
    { title: '图标icon', param: 'icon', type: 'image' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat,width:160},
    { title: '更新时间', param: 'updateTime', formatter: DateFormat,width:160},
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private openCreateVideo() {
    const d = this.$refs.EditPartnerDialog as EditPartnerDialog
    d.open({}, false)
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeletePartner({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }


  public openEditVideo(data: any) {
    const d = this.$refs.EditPartnerDialog as EditPartnerDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryPartnerList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
